// api/getProducts.js

export const CATEGORIES = ['All', 'Phones', 'Laptops', 'Audio', 'Accessories', 'TVs', 'Gaming'];

// Point this at your deployed Worker, e.g.
// https://chikwafu-products-api.<your-subdomain>.workers.dev
// During local dev with `wrangler dev`, this is usually http://localhost:8787
export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8787';

export const WHATSAPP_NUMBER = '256780844098';

const ADMIN_KEY_STORAGE = 'chikwafu_admin_key';

function authHeaders() {
  const key = typeof window !== 'undefined' ? localStorage.getItem(ADMIN_KEY_STORAGE) : null;
  return key ? { Authorization: `Bearer ${key}` } : {};
}

async function handleResponse(res) {
  if (!res.ok) {
    let message = `Request failed (${res.status})`;
    try {
      const body = await res.json();
      if (body?.error) message = body.error;
    } catch {
      // response wasn't JSON — fall back to the generic message above
    }
    throw new Error(message);
  }
  return res.json();
}

/** Fetches the full product catalog from the Worker API. */
export async function getProducts() {
  const res = await fetch(`${API_BASE}/api/products`);
  return handleResponse(res);
}

/** Creates a new product. Requires the admin key to be set via setAdminKey(). */
export async function addProduct(product) {
  const res = await fetch(`${API_BASE}/api/products`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(product),
  });
  return handleResponse(res);
}

/** Partially updates a product by id. Requires the admin key. */
export async function updateProduct(id, updates) {
  const res = await fetch(`${API_BASE}/api/products/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(updates),
  });
  return handleResponse(res);
}

/** Deletes a product by id. Requires the admin key. */
export async function deleteProduct(id) {
  const res = await fetch(`${API_BASE}/api/products/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  return handleResponse(res);
}

/** Stores the admin key used to authorize writes (set this after login). */
export function setAdminKey(key) {
  localStorage.setItem(ADMIN_KEY_STORAGE, key);
}

export function clearAdminKey() {
  localStorage.removeItem(ADMIN_KEY_STORAGE);
}

export function formatUGX(n) {
  return Number(n).toLocaleString('en-UG');
}

export function buildWaLink(text) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}

export function buildOrderLink(product) {
  return buildWaLink(
    `Hi Chikwafu, I'd like to order: ${product.name} - UGX ${formatUGX(product.price)}`
  );
}
